import { Box, Typography } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CustomAppBar from '../components/CustomAppBar';
import Navbar from '../components/Navbar';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import SectionBanner from '../components/SectionBanner';
import PrimaryButton from '../components/PrimaryButton';
import {TextField, Snackbar, Alert} from '@mui/material'
import InputMask from 'react-input-mask';
import SectionBanner2 from '../components/SectionBanner2';
import RadarIcon from '@mui/icons-material/Radar';
import NumbersIcon from '@mui/icons-material/Numbers';
import { queryServer } from '../api/api';
import { useDispatch } from 'react-redux';
import { updateIsVerified, updateTempHeart } from '../redux/heartSlice';
import { getNearbyHearts } from '../api/nearbyHearts';
import NearbyHeartListItem from '../components/NearbyHeartListItem';

function AddHeart() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [nearbyHearts, setNearbyHearts] = React.useState([]);
  const [macAddress, setMacAddress] = useState();
  const [alertOpen, setAlertOpen] = useState(false); // alert popup
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    try{
      getNearbyHearts(setNearbyHearts);
    } catch (error) {
      console.error('Error getting nearby hearts:', error);
      setNearbyHearts([]); // set empty array if error
    }
  }, []);

  const handleCloseAlert = () => {
    setAlertOpen(false);
  };

  const handleAddHeart = async () => {
    // TODO: validate mac address by checking if it is in the correct format


    // TODO: if invalid, display error message

    // if correct format, look up to see if the heart id exists in the database
    try {
      const response = await queryServer(macAddress, 'hearts');
      console.log(response);

      // Can only add a heart that does not already have an owner
      if(response.owner != 'None') {
        setErrorMessage("Heart already has an owner. Please ensure you typed the correct MAC address.")
        setAlertOpen(true);
        return;
      }
      
      await dispatch(updateTempHeart(response));

      // reset isVerified to false (in case of adding 2 hearts)
      // dispatch(updateIsVerified(false));

      // if valid, navigate to add-heart/name to add a name to the heart before adding to store
      navigate('/add-heart/verify')

    } catch (error) {
      setErrorMessage("Heart not found. Please ensure you typed the correct MAC address.")
      setAlertOpen(true);
      console.log(error);
    }

  }

  const handleAddNearbyHeart = (heart) => {
    // add heart to redux store
    dispatch(updateTempHeart(heart));
    // navigate to add-heart/name to add a name to the heart before adding to store
    navigate('/add-heart/verify')
  }

  return (
    <AppContainer>
        {/* Alert popup */}
        <Snackbar
          open={alertOpen}
          autoHideDuration={3000}
          onClose={handleCloseAlert}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={handleCloseAlert} severity="error" sx={{ width: '100%' }}>
              {errorMessage}
          </Alert>
        </Snackbar>

        <CustomAppBar />
        <Navbar />
        <TextContainer>
          <Typography variant='h5' >Add a new Heart</Typography>
          <Typography variant='body2' mt={1.2} sx={{fontSize: '12px', fontStyle: 'italic'}}>Add a Heart by selecting it from the list of nearby Hearts or type the “MAC” address. Please reference the FAQ section in the <a href="https://lumas.live/manual">Lumas Manual</a> for further instructions on how to find the MAC address.</Typography>
        </TextContainer>
        <SectionBanner2 text={"Nearby Hearts"} IconComponent={RadarIcon} customStyles={{marginTop: '20px'}} />
        {/* render nearby hearts if list not empty, if empty then display text saying no nearby hearts*/}
        <TextContainer>
          {nearbyHearts.length === 0 
            ? <Box sx={{display: 'flex', justifyContent: 'center'}}>
                <Typography variant='body2' fontStyle={'italic'} fontSize={'12px'}>No nearby hearts found.</Typography> 
              </Box>
            : nearbyHearts.map((heart, index) => (
              <NearbyHeartListItem key={index} heart={heart} onClick={() => handleAddNearbyHeart(heart)} />
            ))}
        </TextContainer>
        <SectionBanner2 text={"Add Heart by MAC address"} IconComponent={NumbersIcon} />
        <TextContainer>
          <InputMask
            mask="**:**:**:**:**:**"
            value={macAddress}
            disabled={false}
            maskChar="_"
            onChange={(e) => setMacAddress(e.target.value)}
          >
            {() => <TextField label={'MAC Address'} sx={{width: '100%'}} /> }
          </InputMask>
        </TextContainer>
        <PrimaryButton customStyles={{marginTop: '15px'}} text={"Add Heart"} onClick={handleAddHeart} />
    </AppContainer>
  )
}

export default AddHeart